import { render, staticRenderFns } from "./serial-only.vue?vue&type=template&id=43a9974d&scoped=true"
import script from "./serial-only.vue?vue&type=script&lang=js"
export * from "./serial-only.vue?vue&type=script&lang=js"
import style0 from "./serial-only.vue?vue&type=style&index=0&id=43a9974d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a9974d",
  null
  
)

export default component.exports